import showdown from "showdown";
import showdownHighlight from "showdown-highlight";


// Initialize the showdown converter with the highlight plugin
export const markdownConverter = new showdown.Converter({
  sanitize: true,
  extensions: [
    showdownHighlight({
      pre: true, // Add classes to `<pre>` tags for styling
      auto_detection: true, // Enable automatic language detection

    }),
  ],
  tables: true, // Enable tables support
  simplifiedAutoLink: true, // Automatically convert URLs to links
  strikethrough: true, // Enable strikethrough with `~~text~~`
  tasklists: true, // Enable task lists
});

export default markdownConverter;